<template>
  <section class="pt-20">
    <div class="container">
      <div class="lg:w-4/5 pt-20">
        <h1 class="lg:text-5xl/snug text-3xl/snug mt-3">
          {{ blog.Title }}
        </h1>
      </div>
      <!-- featured image -->
      <div class="mt-8">
        <img
          :src="blog.FeaturedImage"
          alt="featured image"
          class="w-full h-96 object-cover rounded-lg"
        />
      </div>
      <div class="mb-8">
        <div class="flex flex-wrap items-center justify-between gap-6">
          <div class="flex items-center gap-3 mt-7">
            <!--            <img-->
            <!--              src="/adminresmigelecek.png"-->
            <!--              alt="avatar"-->
            <!--              class="h-11 w-11 rounded-full"-->
            <!--            />-->
            <div>
              <h6 class="text-sm transition-all hover:text-primary">
                <a href="#">{{ blog.AdminName }}</a>
              </h6>
              <p class="text-sm text-gray-500" v-if="blog.UpdatedAt">
                {{ timeFormatter(blog.UpdatedAt) }}
              </p>
            </div>
          </div>
          <div class="flex gap-2">
            <p class="text-sm text-gray-500">Paylaş:</p>
            <div class="flex gap-3">
              <span
                ><a
                  :href="
                    'https://www.facebook.com/sharer/sharer.php?u=' + currentUrl
                  "
                  target="_blank"
                  ><svg
                    class="w-5 h-5 text-blue-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                    ></path></svg></a></span
              ><span
                ><a
                  :href="'https://twitter.com/intent/tweet?url=' + currentUrl"
                  target="_blank"
                  ><svg
                    class="w-5 h-5 text-teal-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
                    ></path></svg></a></span
              ><span
                ><a href="https://www.instagram.com/direct/new/" target="_blank"
                  ><svg
                    class="w-5 h-5 text-red-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect
                      x="2"
                      y="2"
                      width="20"
                      height="20"
                      rx="5"
                      ry="5"
                    ></rect>
                    <path
                      d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                    ></path>
                    <line
                      x1="17.5"
                      y1="6.5"
                      x2="17.51"
                      y2="6.5"
                    ></line></svg></a
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="flex flex-col min-h-screen">
    <div class="container">
      <div v-html="blog.Content"></div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { getBlog, timeFormatter } from "@/services/contentService";
import { useLoadingStore } from "@/stores/loadingStore";

// `setup` fonksiyonu içinde `useRoute`'u çağırıyoruz.
const route = useRoute();
const currentUrl = ref(window.location.href);
const loadingStore = useLoadingStore();

var slug = route.path;

const blog = ref("");

// `slug` parametresini console'a yazdırıyoruz
loadingStore.startLoading();
getBlog(slug).then((data) => {
  loadingStore.finishLoading();
  blog.value = data;
});
</script>
